import type { Coin } from '@asia/shared';
import { CoinIcon } from '../CoinIcon';
import { fmtUsd, fmtPrice, fmtPct, priceDecimals, groupInt } from '../../lib/format';

export function AssetRow({
  coin,
  loading,
  onClick,
}: {
  coin: Coin;
  loading?: boolean;
  onClick?: () => void;
}) {
  const up = coin.change24h >= 0;
  return (
    <button
      onClick={onClick}
      className="flex w-full items-center gap-3 px-4 py-3 text-left active:bg-black/[0.03]"
    >
      <CoinIcon symbol={coin.symbol} size={40} />
      <div className="min-w-0 flex-1">
        <p className="text-[16px] font-semibold text-ink">{coin.name}</p>
        <p className="text-[13px] text-muted">
          <span className="font-medium text-ink">
            {fmtPrice(coin.priceUsd, priceDecimals(coin.symbol))}
          </span>{' '}
          <span className={`text-[12px] ${up ? 'text-positive' : 'text-negative'}`}>
            {fmtPct(coin.change24h)}
          </span>
        </p>
      </div>
      <div className="text-right">
        {loading ? (
          <>
            <p className="ml-auto h-4 w-20 animate-pulse rounded bg-black/10" />
            <p className="ml-auto mt-1 h-3 w-14 animate-pulse rounded bg-black/5" />
          </>
        ) : (
          <>
            <p className="text-[16px] font-semibold text-ink">
              {groupInt(coin.balance)} {coin.symbol}
            </p>
            <p className="text-[13px] text-muted">{fmtUsd(coin.balance * coin.priceUsd)}</p>
          </>
        )}
      </div>
    </button>
  );
}
